import type { ILogger } from './log.if';
import { LOG_LEVEL } from './log.if';

const logMap: Record<LOG_LEVEL, (message: string) => void> = {
    /* eslint-disable no-console */
    [LOG_LEVEL.MILESTONE]: message => {
        console.info(message);
    },
    [LOG_LEVEL.TRACE]: message => {
        console.debug(message);
    },
    [LOG_LEVEL.VERBOSE]: message => {
        console.debug(message);
    },
    [LOG_LEVEL.INFO]: message => {
        console.info(message);
    },
    [LOG_LEVEL.WARN]: message => {
        console.warn(message);
    },
    [LOG_LEVEL.ERROR]: message => {
        console.error(message);
    },
    [LOG_LEVEL.FATAL]: message => {
        console.error(message);
    },
    [LOG_LEVEL.ASSERT]: message => {
        console.assert(true, message);
    },
    /* eslint-enable no-console */
};

function _consoleLog(logLevel: LOG_LEVEL, message: string): void {
    logMap[logLevel](message);
}

function logger(levels: LOG_LEVEL[]): ILogger {
    const object: ILogger = {
        assert: (condition, message) => {
            const fireBoolean = typeof condition === 'boolean' && condition;
            const fireNumber = typeof condition === 'number' && condition !== 0;
            const fireString = typeof condition === 'string' && condition.length > 0;

            if (fireBoolean || fireNumber || fireString) {
                _consoleLog(LOG_LEVEL.ASSERT, message);
            }
        },
        log: (level, msg) => {
            _consoleLog(level, msg);
        },
    };

    return object;
}

export default logger;
